import type { NewClosedProjectsPeriod } from '@models/interfaces';

import themeColors from 'styles/theme/colors.module.scss';

type NewClosedProjectsSeriesKey = keyof Pick<
  NewClosedProjectsPeriod,
  'closedCount' | 'newCount'
>;

interface NewClosedProjectsSeriesConfig {
  dataKey: NewClosedProjectsSeriesKey;
  fill: string;
  name: string;
}

export const NEW_CLOSED_PROJECTS_CHART_COLORS = {
  closed: themeColors.turquoise,
  cumulative: themeColors.yellow,
  new: themeColors.hoverPrimary,
};

export const NEW_CLOSED_PROJECTS_AREA_SERIES: NewClosedProjectsSeriesConfig[] =
  [
    {
      dataKey: 'newCount',
      fill: NEW_CLOSED_PROJECTS_CHART_COLORS.new,
      name: 'New Projects',
    },
    {
      dataKey: 'closedCount',
      fill: NEW_CLOSED_PROJECTS_CHART_COLORS.closed,
      name: 'Closed Projects',
    },
  ];

export const hasNewClosedProjectsSeriesData = (
  series: NewClosedProjectsPeriod[],
): boolean => series.length > 0;
